import React from "react";
import { ImageWithSkeleton } from "../../../components/ImageWithSkeleton/ImageWithSkeleton";

const HERO_IMG = "https://i.ibb.co/Sy7wJsp/person1-1-1-1-1.png";

const scrollToSection = (id) => {
  if (id === "top") {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  const target = document.getElementById(id);
  if (!target) return;

  const nav = document.querySelector(".site-nav");
  const navHeight = nav ? nav.getBoundingClientRect().height : 0;
  const extraSpace = 0;
  const targetTop =
    target.getBoundingClientRect().top +
    window.pageYOffset -
    navHeight -
    extraSpace;

  window.scrollTo({
    top: Math.max(targetTop, 0),
    behavior: "smooth",
  });
};

const Banner = () => {
  return (
    <section className="hero" id="top" data-aos="fade-up">
      <div>
        <p className="hero__kicker">Full-stack · Product</p>
        <h1 className="hero__title">Software with patience baked in.</h1>
        <p className="hero__lead">
          I’ve spent years where pixels, performance, and backend reality have to
          agree—page builders, commerce, internal tools, and lately AI-native
          products I ship under my own name. I like small teams, honest scope, and
          work that still makes sense in a year.
        </p>
        <div className="hero__actions">
          <a
            className="hero__link"
            href="https://github.com/h-zahar"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
          <a
            className="hero__link"
            href="https://www.linkedin.com/in/h-zahar/"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </a>
          <a
            className="hero__link"
            href="https://x.com/hzaharr"
            target="_blank"
            rel="noreferrer"
          >
            X (Twitter)
          </a>
          <button
            type="button"
            className="hero__btn"
            onClick={() => scrollToSection("contact")}
          >
            Say hello
          </button>
        </div>
      </div>
      <aside className="hero__aside">
        <ImageWithSkeleton
          variant="hero"
          className="hero__photo"
          src={HERO_IMG}
          alt="Hassan Zahar Rifat"
          width={312}
          height={392}
        />
        <p className="hero__caption">localhost &#8594; live</p>
      </aside>
    </section>
  );
};

export default Banner;
